import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function IncludedSection() {
  const blocks = [{
    day: 'Día 1-2',
    title: 'Reset del entorno',
    desc: 'Dormir en temperatura ideal, eliminar luz, mejorar descanso desde la primera noche.'
  }, {
    day: 'Día 3-4',
    title: 'Comida que induce sueño',
    desc: 'Qué cenar exactamente para producir melatonina natural.'
  }, {
    day: 'Día 5-6',
    title: 'Movimiento correcto',
    desc: 'Ejercicio que baja cortisol (no lo dispara).'
  }, {
    day: 'Día 7',
    title: 'Rutina para dormir profundo',
    desc: 'Sistema de 60 minutos que apaga tu sistema nervioso.'
  }, {
    day: 'Bonus',
    title: 'Checklist de 30 días',
    desc: 'Para ver resultados reales semana a semana.'
  }];
  return <section className="py-24 bg-cream relative" data-id="element-139">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-140">
        <FadeIn data-id="element-141">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-charcoal mb-16" data-id="element-142">
            Qué incluye el plan
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-143">
          {blocks.map((block, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-144">
              <div className="bg-white rounded-2xl p-6 md:p-8 shadow-card border border-cream-dark/50 flex flex-col md:flex-row items-start md:items-center gap-6 relative overflow-hidden group" data-id="element-145">
                {/* Decorative side accent */}
                <div className="absolute left-0 top-0 bottom-0 w-2 bg-terracotta/20 group-hover:bg-terracotta transition-colors duration-300" data-id="element-146"></div>

                <div className="flex-shrink-0 bg-cream-alt px-6 py-3 rounded-xl border border-cream-dark/30 min-w-[140px] text-center" data-id="element-147">
                  <span className="font-serif font-bold text-terracotta-dark text-lg" data-id="element-148">
                    {block.day}
                  </span>
                </div>

                <div data-id="element-149">
                  <h3 className="text-xl font-bold text-charcoal mb-2" data-id="element-150">
                    {block.title}
                  </h3>
                  <p className="text-charcoal-light text-lg" data-id="element-151">{block.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}